import { FormControl, MenuItem, Select } from "@mui/material";
import React, { useEffect } from "react";
import { vsprintf } from "sprintf-js";
import { replaceBracketPlaceholders } from "../utilities/replaceBracketPlaceholder";
import FixedDecimalTextField from "../components/FixedDecimalTextField";

const ColumnQuantity = ({
  params,
  item,
  quantitySelectOptions,
  handleRowUpdate,
  formAction,
  documentSelectTableData,
  rowError,
}) => {
  return (
    <section style={{ display: "flex", flexDirection: "column", gap: 0 }}>
      <div style={{ display: "flex" }}>
        <QuantityNumberComponent
          params={params}
          item={item}
          handleRowUpdate={handleRowUpdate}
          formAction={formAction}
          documentSelectTableData={documentSelectTableData}
          rowError={rowError}
        />

        <QuantitySelectComponent
          params={params}
          item={item}
          quantitySelectOptions={quantitySelectOptions}
          handleRowUpdate={handleRowUpdate}
        />
      </div>
    </section>
  );
};

function QuantityNumberComponent({
  params,
  item,
  handleRowUpdate,
  formAction,
  documentSelectTableData,
  rowError,
}) {
  useEffect(() => {
    const currentValue = params?.row?.[item?.sColumnID];

    const hasExistingValue =
      currentValue !== undefined &&
      currentValue !== null &&
      String(currentValue).trim() !== "";

    if (hasExistingValue) return;

    if (formAction !== "EDIT" && documentSelectTableData?.length === 0) {
      handleRowUpdate({
        fieldName: item?.sColumnID,
        value: item?.inputType?.component?.sDefaultValue,
        rowId: params?.row?.id,
      });
    }
  }, []);

  const fieldId =
    params?.row?._fieldIds?.[item?.sColumnID] ||
    item?.inputType?.component?.sName;

  return (
    <FixedDecimalTextField
      component={item?.inputType?.component}
      placeholder={item?.inputType?.component?.sPlaceHolder}
      error={!!rowError}
      helperText={rowError || ""}
      id={`${fieldId}-${params?.row?.id}`}
      value={params?.row?.[item?.sColumnID] ?? ""}
      onValueChange={value => {
        handleRowUpdate({
          fieldName: item?.sColumnID,
          value,
          rowId: params?.row?.id,
        });
      }}
    />
  );
}

function QuantitySelectComponent({
  params,
  item,
  quantitySelectOptions,
  handleRowUpdate,
}) {
  const fieldId =
    params?.row?._fieldIds?.[item?.sColumnID] ||
    item?.inputType?.component?.sName;

  return (
    <FormControl
      {...item?.inputType?.component?.sProps}
      {...item?.inputType?.component?.options?.others1}
    >
      <Select
        id={`${fieldId}-type-${params?.row?.id}`}
        value={params?.row?.col_qty_select ?? ""}
        onChange={(e) => {
          const selectedValue = e?.target?.value;
          const selectedOption = quantitySelectOptions?.find(
            option => option?.[item?.inputType?.data?.sValueField] === selectedValue,
          );
          handleRowUpdate({
            rowId: params?.row?.id,
            fieldName: "col_qty_select",
            value: selectedValue,
            colItemData: selectedOption,
          });
        }}
        {...item?.inputType?.component?.sProps}
        {...item?.inputType?.component?.options?.others1}
      >
        {quantitySelectOptions?.map((qtySelectItem, index) => (
          <MenuItem
            key={index}
            value={qtySelectItem[item?.inputType?.data?.sValueField]}
          >
            <div
              component="span"
              style={{ width: "100%" }}
              dangerouslySetInnerHTML={{
                __html:
                  qtySelectItem &&
                  qtySelectItem !== "" &&
                  Object.keys(qtySelectItem).length !== 0
                    ? vsprintf(
                        item?.inputType?.data?.sDisplayFormat,
                        replaceBracketPlaceholders(
                          item?.inputType?.data?.sDisplayField,
                          qtySelectItem
                        )
                          .replace(/[{}]/g, "")
                          .split(",")
                      )
                    : "",
              }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default ColumnQuantity;
